import { Group, MantineTheme, Text } from "@mantine/core";
import { CircleFilledIcon } from "@mcurros2/microm";
import { IconAlertHexagonFilled, IconAlertSquareFilled, IconAlertTriangleFilled, IconCheck } from "@tabler/icons-react";
import { ReactNode } from "react";

export function CoberturaTiendasViewColumnsOverrides(theme: MantineTheme) {
    return {
        // Personal asignado
        4: {
            render: (value: unknown) => (!value) ? <Group style={{ gap: '.5rem' }} noWrap>
                <IconAlertHexagonFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                <Text truncate>Sin personal</Text>
            </Group> : value as ReactNode
        },

        // Cobertura compartida
        5: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val === 'Sin rutas compartidas asignadas') {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertHexagonFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>Sin rutas compartidas asignadas</Text>
                    </Group>
                }
                if (val.endsWith('horas compartidas sobreasignadas')) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertSquareFilled style={{ color: theme.colors.orange[6], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>{value as ReactNode}</Text>
                    </Group>
                }
                if (val.endsWith('horas compartidas no cubiertas')) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertTriangleFilled style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text>{value as ReactNode}</Text>
                    </Group>
                }
                if (val === 'OK') {
                    return <CircleFilledIcon mr="xs" width="1.3rem" icon={<IconCheck size="0.9rem" />} />
                }
                return value as ReactNode;
            }
        },

        // Cobertura exclusiva
        6: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val === 'Sin rutas exclusivas asignadas') {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertHexagonFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>Sin rutas exclusivas asignadas</Text>
                    </Group>
                }
                if (val.endsWith('horas exclusivas sobreasignadas')) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertSquareFilled style={{ color: theme.colors.pink[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>{value as ReactNode}</Text>
                    </Group>
                }
                if (val.endsWith('horas exclusivas no cubiertas')) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertTriangleFilled style={{ color: theme.colors.grape[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>{value as ReactNode}</Text>
                    </Group>
                }
                if (val === 'OK') {
                    return <CircleFilledIcon mr="xs" width="1.3rem" icon={<IconCheck size="0.9rem" />} />
                }
                return value as ReactNode;
            }
        },

        // Cantidad de clientes
        12: {
            render: (value: unknown) => (!value || value === '0') ? <Group style={{ gap: '.5rem' }} noWrap>
                <IconAlertHexagonFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                <Text truncate>Sin clientes</Text>
            </Group> : value as ReactNode
        },
        // Cantidad de productos
        13: {
            render: (value: unknown) => (!value || value === '0') ? <Group style={{ gap: '.5rem' }} noWrap>
                <IconAlertHexagonFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                <Text truncate>Sin productos</Text>
            </Group> : value as ReactNode
        },


    }
}